module.exports = __webpack_public_path__ + "img/cx.4435592d.png";